<!--title -->
<app-modal-title
  [title]="'common.signature' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form">
    <div class="row" style="max-width: 500px">
      <!-- help message -->
      <div
        class="flex tw-px-5 tw-my-2 *:tw-text-primary-700 *:dark:tw-text-primary-200 *:tw-font-medium *:tw-text-[14px]"
      >
        <p [innerHTML]="'messages.uneditableSignature' | translate"></p>
        <p
          class="tw-mb-2"
          [innerHTML]="'messages.isExistSignatureInSmsBody' | translate"
        ></p>
      </div>

      <div class="tw-w-full">
        <!-- privateNumber Signature -->
        <!-- TODO textarea rashidi -->
        <div class="tw-my-1">
          <!-- <mat-form-field appearance="outline" class="tw-w-full tw-opacity-70">
            <mat-label>{{ "common.privateNumberSignature" | translate }}</mat-label>
            <textarea matInput formControlName="signature" class="tw-text-lg font-vazir-ui" rows="2" readonly></textarea>
          </mat-form-field> -->
          <form-textarea
            class="tw-w-full tw-opacity-70"
            label="common.privateNumberSignature"
            [(value)]="smsBodyWithSignatures"
            [control]="form?.get('signature')"
            [rows]="2"
            [isReadOnly]="true"
          >
          </form-textarea>
        </div>

        <!-- organization Signature -->
        <!-- TODO textarea torbatian -->
        <div class="tw-my-1">
          <mat-form-field appearance="outline" class="tw-w-full">
            <mat-label>{{
              "common.organizationSignature" | translate
            }}</mat-label>
            <textarea
              #organSignature
              matInput
              formControlName="organizationSignature"
              class="tw-text-lg font-vazir-ui"
              (input)="onChangeOrganSignature(organSignature.value)"
              rows="2"
            ></textarea>
          </mat-form-field>
        </div>

        <!-- position -->
        <div class="tw-my-2" *ngIf="!isExitSignatureInSmsBody">
          <custom-select-search
            label="common.position"
            [items]="
              $any([
                {
                  value: false,
                  name: 'common.privateNumberSignatureAtFirst' | translate
                },
                {
                  value: true,
                  name: 'common.organSignatureAtFirst' | translate
                }
              ])
            "
            [control]="form?.get('signaturePosition')"
            optionTitle="name"
            optionValue="value"
            [removable]="false"
            [(value)]="isOrganSignatureAtFirst"
            (valueChange)="onChangeSignaturePosition($event)"
          >
          </custom-select-search>
        </div>
      </div>

      <div class="tw-w-full">
        <!-- smsBodyWithSignature -->
        <div class="tw-my-1">
          <form-textarea
            class="tw-w-full"
            label="common.smsBody"
            [(value)]="smsBodyWithSignatures"
            [control]="form?.get('smsBody')"
            [rows]="5"
          >
          </form-textarea>
        </div>
      </div>
    </div>

    <!-- submit btn -->
    <div class="tw-flex tw-justify-end">
      <div
        class="tw-flex tw-justify-end tw-w-full tw-mt-2"
        style="max-width: 275px"
      >
        <a
          mat-ripple
          class="btn tw-ml-[5px] ltr:tw-mr-[5px] tw-w-1/2 button-shadow btn-hover-rise"
          [themeColor]="'cancel-btn'"
          (click)="onClose()"
        >
          {{ "common.cancel" | translate }}
        </a>

        <button
          type="button"
          (click)="onSuccess()"
          mat-ripple
          class="btn tw-w-full button-shadow btn-hover-rise"
          [themeColor]="'btn'"
          [disabled]="!form.valid"
        >
          <span>{{ "common.submit" | translate }}</span>
        </button>
      </div>
    </div>
  </form>
</div>
